module.exports = __webpack_public_path__ + "bw.svg?15ed460a57847531507e5ba7201597b5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bw.svg
// module id = 1278
// module chunks = 0